import axiosIns from 'utils/axios'
let epmcore = 'EPM-CORE-SERVICE'

// 获取字典组
export function getDictGroup (data) {
  return axiosIns({
    url: `/api/pc/companyDict/dictGroup/page`,
    owner: epmcore,
    method: 'get',
    params: data
  })
}
// 获取字典组id获取字典项
export function getCompanyDictPage (data) {
  return axiosIns({
    url: `/api/pc/companyDict/page`,
    owner: epmcore,
    method: 'get',
    params: data
  })
}

/**
 * 根据id分页查询字典项
 * @param {id} id 
 * @param {*params} params 
 */
export function pageDictItem (id, params) {
  return axiosIns({
    url: `/api/pc/dict/page/${id}`,
    owner: epmcore,
    method: 'get',
    params: params
  })
}

// 更新字典项
export function updateCompanyDict (data) {
  return axiosIns({
    url: `/api/pc/companyDict/update`,
    owner: epmcore,
    method: 'put',
    data: data
  })
}
// 新增字典项
export function addCompanyDict (data) {
  return axiosIns({
    url: `/api/pc/companyDict/add`,
    owner: epmcore,
    method: 'post',
    data: data
  })
}
// 删除字典项
export function removeCompanyDictById (id) {
  return axiosIns({
    url: `/api/pc/companyDict/${id}`,
    owner: epmcore,
    method: 'delete'
  })
}





// WEBPACK FOOTER //
// ./src/views/system-manage/dict/dictAPI.js